import { dehydrate, DehydratedState, QueryClient } from "@tanstack/react-query";
import type { GetServerSideProps, NextPage } from "next";

import { ESeoPage } from "@/utils/mockData/metaMocks";
import {
    getBrochureData,
    getItalianStoriesData,
    getNavBarData,
    getSeoInfo,
} from "@/utils/queries";
import useGeneralItalianStoriesData from "@/utils/queries/hooks/useGeneralItalianStoriesData";
import { getOpenGraphDataItalianStories } from "@/utils/seo";
import Seo from "@/components/common/Seo";
import useItalianStory from "@/utils/queries/hooks/useItalianStory";
import { withRedirect } from "@/utils/redirects";
import ItalianStoriesBody from "../../components/italianStories/ItalianStoriesBody";

const ItalianStoriesPage: NextPage = () => {
    // const { data: metaTags } = useQuery({
    //     queryKey: ["metaTags", ESeoPage.ITALIANSTORIES],
    //     queryFn: () => getSeoInfo(ESeoPage.ITALIANSTORIES),
    // });

    const { data: italianStoriesData } = useGeneralItalianStoriesData();
    const { data: italianStoryData } = useItalianStory();
    const metadata = getOpenGraphDataItalianStories(
        italianStoryData?.playItalyStory,
        italianStoriesData
    );

    return (
        <>
            <Seo
                seoInfo={metadata}
                noindex={!italianStoryData?.playItalyStory?.metadata?.index}
            />
            <ItalianStoriesBody />
        </>
        // </Layout>
    );
};

export const getServerSideProps: GetServerSideProps = withRedirect(
    async (): Promise<{
        props: {
            dehydratedState: DehydratedState;
        };
    }> => {
        const queryClient = new QueryClient();

        await Promise.all([
            await queryClient.prefetchQuery(["navBar"], getNavBarData),
            await queryClient.prefetchQuery(["brochures"], getBrochureData),
            await queryClient.prefetchQuery(["italian-stories-data"], () =>
                getItalianStoriesData()
            ),
            await queryClient.prefetchQuery(
                ["metaTags", ESeoPage.ITALIANSTORIES],
                () => getSeoInfo(ESeoPage.ITALIANSTORIES)
            ),
        ]);
        return {
            props: {
                dehydratedState: dehydrate(queryClient),
            },
        };
    }
);

export default ItalianStoriesPage;
